export default "__VITE_ASSET__2e30874a__"